<template>
  <v-expansion-panel-content
    v-bind='$props'
    class='w-expansion-panel-content'
    v-on='$listeners'
  >
    <slot />
  </v-expansion-panel-content>
</template>

<script>
import { VExpansionPanelContent } from "vuetify/lib";

export default {
  name: 'WorkExpansionPanelContent',
  props: { ...VExpansionPanelContent.options.props }
};
</script>

<style lang='scss' scoped>
.w-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  $content-padding: $grid-gutter;
  background-color: var(--v-work_card-base);
  padding: 0 $content-padding $content-padding;
  box-shadow: none !important;
}
</style>
